import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CidadeAtuacao {
  id: string;
  estado_id: string;
  nome_cidade: string;
  destaque: boolean;
  ativo: boolean;
}

export interface EstadoAtuacao {
  id: string;
  nome_estado: string;
  sigla: string;
  regiao: string;
  tipo_operacao: string;
  ativo: boolean;
  total_clientes: number;
  ano_inicio: number;
  cidades: CidadeAtuacao[];
}

export const useAtuacao = () => {
  return useQuery({
    queryKey: ["atuacao"],
    queryFn: async (): Promise<EstadoAtuacao[]> => {
      const { data: estados, error: estadosError } = await supabase
        .from("estados_atuacao" as any)
        .select("*")
        .eq("ativo", true)
        .order("ano_inicio", { ascending: true });

      if (estadosError) throw estadosError;

      const { data: cidades, error: cidadesError } = await supabase
        .from("cidades_atuacao" as any)
        .select("*")
        .eq("ativo", true);

      if (cidadesError) throw cidadesError;

      const estadosTyped = (estados as any[]) || [];
      const cidadesTyped = (cidades as any[]) || [];

      return estadosTyped.map((estado) => ({
        ...estado,
        cidades: cidadesTyped.filter((c) => c.estado_id === estado.id),
      }));
    },
    staleTime: 5 * 60 * 1000,
  });
};
